import { Col, Input, Row, Select } from "antd";
import * as React from "react";
import { languages } from "common/i18n";
import * as intl from 'react-intl-universal';
import { CaretDownOutlined } from '@ant-design/icons';
const { Option } = Select;
const InputGroup = Input.Group;

export default class Address extends React.Component<any> {
    state = {
        buildingSelect: 'building',
        roomSelect: 'room',
        buildingInput: '',
        roomInput: '',
        district: '',
        street: '',
        community: '',
        isEn: false,
    };

    enFields: any = {
        'building': 'Building',
        'tower': 'Tower',
        'room': 'Room',
        'flat': 'Flat',
        'unit': 'Unit'
    };

    componentDidMount() {
       this.initData();
    }

    initData = () =>{
        const { value = {}, english } = this.props;
        const { buildingSelect, buildingInput, roomSelect, roomInput, district, street, community } = this.formatValue(value);
        this.setState({
            buildingSelect, buildingInput, roomSelect, roomInput, district, street, community,
            isEn: languages.getDefault() === 'en-US' || english
        });
    }

    UNSAFE_componentWillReceiveProps({ transValue, destroyTransValue, disabled }: any) {
        !disabled && transValue && JSON.stringify(transValue) !== "{}" && this.setState(transValue, () => destroyTransValue && destroyTransValue());
    }

    // 值变化
    changeHandler = (index: 0 | 1, inputValue: string, innerKey: string, wrapperKey: any) => {
        const { onChange, value = {} } = this.props;
        const copyValue = JSON.parse(JSON.stringify(value));
        const { buildingInput, roomInput, buildingSelect, roomSelect } = this.state;
        if (copyValue[wrapperKey] && index === 1) {
            copyValue[wrapperKey][innerKey] = inputValue;
        } else {
            copyValue[wrapperKey] = { [innerKey]: inputValue };
        }
        if (wrapperKey === 'buildingSelect') {
            index === 1 ? this.setState({ buildingInput: inputValue }) :
            copyValue[wrapperKey] = { [buildingSelect]: buildingInput };
        } else if (wrapperKey === 'roomSelect') {
            index === 1 ? this.setState({ roomInput: inputValue }) :
            copyValue[wrapperKey] = { [roomSelect]: roomInput };
        }
        wrapperKey === 'inputValue' && this.setState({ [innerKey]: inputValue });
        onChange && onChange(copyValue);
    };

    // 失焦
    blurHandler = (key?: string, wrapperKey?: string) => {
        const { value = {}, onBlur, onChange, transToEnglish } = this.props;
        transToEnglish && transToEnglish(key, this.state, wrapperKey);
        onBlur ? onBlur(value) : onChange && onChange(value);
    };

    selectChange = (selectvalue: any, key: string) => {
        const { transToEnglish } = this.props;
        transToEnglish && transToEnglish(key, selectvalue, 'select');
        this.setState({ [key]: selectvalue }, () => {
            this.changeHandler(0, null, selectvalue, key);
        });
    };

    // 首字母转大写
    fistLetterUpper = (value: any) => {
        return value.charAt(0).toUpperCase() + value.slice(1);
    };

    // 地址
    formatValue = (value: any = {}) => {
        const { buildingSelect: buildingData, roomSelect: roomData, inputValue = {} } = value;
        const building = [buildingData && Object.keys(buildingData)[0], buildingData && Object.values(buildingData)[0]];
        const room = [roomData && Object.keys(roomData)[0], roomData && Object.values(roomData)[0]];
        let buildingSelect: any = building[0] ? building[0] : 'building';
        let buildingInput: any = building[1] ? building[1] : '';
        let roomSelect: any = room[0] ? room[0] : 'room';
        let roomInput: any = room[1] ? room[1] : '';
        let district = inputValue.district || '';
        let street = inputValue.street || '';
        let community = inputValue.community || '';
        return { buildingSelect, buildingInput, roomSelect, roomInput, district, street, community };
    }

    getStaticView = () => {
        const { english, value={} } = this.props;
        const { isEn } = this.state;
        const { buildingSelect, buildingInput, roomSelect, roomInput, district, street, community } = this.formatValue(value);
        const addresFields: any = {
            district: `${district || '-'} ${english ? 'District' : intl.get('Global.District')}`,
            street: `${street || '-'} ${english ? 'Street' : intl.get('Global.Street')}`,
            community: `${community || '-'}`,
            buildingSelect: `(${english ? this.enFields[buildingSelect] : intl.get(`Global.${this.fistLetterUpper(buildingSelect)}`)}) ${buildingInput || '-'}`,
            roomSelect: `(${english ? this.enFields[roomSelect] : intl.get(`Global.${this.fistLetterUpper(roomSelect)}`)}) ${roomInput || '-'}`
        };
        let res = ['district', 'street', 'community', 'buildingSelect', 'roomSelect'];
        isEn && res.reverse();
        return <span style={{wordBreak: 'break-all'}}>{(!district && !street && !community && !buildingInput && !roomInput) ? '-' : res.map((item: string) => addresFields[item]).join(',')}</span>;
    }

    render() {
        const { english, staticView, disabled, value={} } = this.props;
        const { isEn } = this.state;
        const { buildingSelect, buildingInput, roomSelect, roomInput, district, street, community } = this.formatValue(value);
        return (staticView && disabled) ? this.getStaticView()
            :
            <InputGroup className='address' style={{ display: 'flex', flexDirection: isEn ? 'column-reverse': 'column' }}>
                <Row style={isEn ? {display: 'flex', flexDirection: 'row-reverse',marginTop: 5} : { display: 'flex' }}>
                    <Col className='address-col'>
                        <Input placeholder={english ? 'District' : intl.get('Global.District')}
                            value={district || ''}
                            onBlur={() => this.blurHandler('district', 'inputValue')}
                            onChange={(e: any) => this.changeHandler(1, e.target.value, 'district', 'inputValue')} />
                        <span className='label'>{english ? 'District' : intl.get('Global.District')},</span>
                    </Col>
                    <Col className='address-col'>
                        <Input placeholder={english ? 'Street' : intl.get('Global.Street')}
                            value={street || ''}
                            onBlur={() => this.blurHandler('street', 'inputValue')}
                            onChange={(e: any) => this.changeHandler(1, e.target.value, 'street', 'inputValue')} />
                        <span className='label'>{english ? 'Street' : intl.get('Global.Street')},</span>
                    </Col>
                    <Col className='address-col'>
                        <Input placeholder={english ? 'Community' : intl.get('Global.Community')}
                            value={community || ''}
                            onBlur={() => this.blurHandler('community', 'inputValue')}
                            onChange={(e: any) => this.changeHandler(1, e.target.value, 'community', 'inputValue')} />
                        <span className='label'>,</span>
                    </Col>
                </Row>
                <Row style={isEn ? { display: 'flex', flexDirection: 'row-reverse', justifyContent: 'flex-end' } : { display: 'flex', marginTop: 5 }}>
                    <Col span={11}>
                        <InputGroup className='address-col' compact>
                            <Select
                                style={{ width: 130, marginRight: 5 }}
                                defaultValue='building'
                                value={buildingSelect}
                                onSelect={(v: any) => !english && this.selectChange(v, 'buildingSelect')}
                                dropdownClassName='set-index' suffixIcon={<CaretDownOutlined />}>
                                <Option value='building'>{english ? 'Building' : intl.get('Global.Building')}</Option>
                                <Option value='tower'>{english ? 'Tower' : intl.get('Global.Tower')}</Option>
                            </Select>
                            <Input
                                placeholder={english ? this.enFields[buildingSelect] : intl.get(`Global.${this.fistLetterUpper(buildingSelect)}`)}
                                value={buildingInput}
                                onChange={(e: any) => this.changeHandler(1, e.target.value, buildingSelect, 'buildingSelect')}
                                onBlur={() => this.blurHandler('buildingInput', 'buildingSelect')} />
                        </InputGroup>
                    </Col>
                    <Col span={1}>
                        <span className='label'>{','}</span>
                    </Col>
                    <Col span={11}>
                        <InputGroup className='address-col' compact>
                            <Select
                                style={{ width: 130, marginRight: 5 }}
                                defaultValue='room'
                                value={roomSelect}
                                dropdownClassName='set-index'
                                onSelect={(v: any) => !english && this.selectChange(v, 'roomSelect')}
                                suffixIcon={<CaretDownOutlined />}>
                                <Option value='room'>{english ? 'Room' : intl.get('Global.Room')}</Option>
                                <Option value='flat'>{english ? 'Flat' : intl.get('Global.Flat')}</Option>
                                <Option value='unit'>{english ? 'Unit' : intl.get('Global.Unit')}</Option>
                            </Select>
                            <Input
                                placeholder={english ? this.enFields[roomSelect] : intl.get(`Global.${this.fistLetterUpper(roomSelect)}`)}
                                value={roomInput}
                                onChange={(e: any) => this.changeHandler(1, e.target.value, roomSelect, 'roomSelect')}
                                onBlur={() => this.blurHandler('roomInput', 'roomSelect')} />
                        </InputGroup>
                    </Col>
                </Row>
            </InputGroup>;
    }
}
